module.exports = __webpack_public_path__ + "img/Img5c_204710_BgFg-2-473.e60cbf5a.jpg";